import React, { Component } from 'react'
import {
  i18nTranslate,
  isExpressCheckout,
  enableNewFeature,
  IS_BROWSER,
} from 'src/utils'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { customerContainer, contentStackContainer } from 'src/models'
import { AiOutlineMenu as MenuIcon } from 'react-icons/ai'
import { AiOutlineSearch as SearchIcon } from 'react-icons/ai'
import { Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { pageNames } from 'src/routes/pathParams'
import { PageLink as PageLinks } from 'src/views/components/PageLink'
import LocaleModal from '../../LocaleModal'
import {
  HeaderLogo,
  mobileMenuState,
  UserMenu,
  CartIcon,
  // FavoriteIconWithLink,
} from 'src/views/components'
import { application } from 'src/utils'
import { isValidUrl } from 'src/utils/commonUtils'
import {
  convertToBoolean,
  getAppConfig,
  getBuyNowInPDP,
} from 'config/appConfig'
import NavSearchIcon from '../Components/SearchBox/NavSearchIcon'
import MarketSelector from './MarketLanguage/MarketSelector'
import { SearchBox } from '../Components/SearchBox'
import { isEquinoxPOSite, getPersonalOfferPitchId } from 'src/utils/mySiteUtils'
import './newStyles.scss'

@observer
class SearchSection extends Component {
  nameSpace = 'ssr-resource'
  @observable searchFocused = false
  @observable searchCleared = false

  constructor(props, context) {
    super(props, context)
    this.marketSelectorRef = React.createRef()
    this.searchBtnRef = React.createRef()
  }

  componentDidMount() {
    if (enableNewFeature('enableNewHeaderNavigation')) {
      // Set search data in customerContainer
      try {
        const searchData = JSON.parse(JSON.stringify(this.props.searchData))
        if (searchData) {
          customerContainer.setSearchData(searchData)
        }
      } catch (error) {
        console.log('Error in getting searchData from content stack', error)
      }
    }
    document.addEventListener('keydown', this.handleGlobalKeyDown)
  }

  handleGlobalKeyDown = event => {
    if (event.key === 'Tab' && this.searchBtnRef) {
      this.searchBtnRef.current.classList.remove('focus-disable')
    }
  }

  componentDidUpdate(prevProps) {
    if (enableNewFeature('enableNewHeaderNavigation')) {
      try {
        const searchData = JSON.parse(JSON.stringify(this.props.searchData))
        if (prevProps.searchData !== this.props.searchData) {
          customerContainer.setSearchData(searchData)
        }
      } catch (error) {
        console.log('Error in getting searchData from content stack', error)
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleGlobalKeyDown)
  }

  callMarketFunction = () => {
    if (this.marketSelectorRef?.current?.handleShow) {
      this.marketSelectorRef.current.handleShow('lg')
    } else {
      console.log(
        'NavigationBar - handleShow method not available on MarketSelector'
      )
    }
  }

  toggleSearchModal = value => {
    this.searchFocused = value
  }

  closeSearchModal = () => {
    this.searchFocused = false
    this.searchCleared = false
    if (this.searchBtnRef) {
      this.searchBtnRef.current.classList.add('focus-disable')
    }
  }

  closeSearchSectionModal = () => {
    this.searchFocused = false
  }

  clearSearchModal = value => {
    this.searchCleared = value
    if (this.searchBtnRef) {
      this.searchBtnRef.current.classList.add('focus-disable')
    }
  }
  harmsburg = (isGuestB2B, requestDomain) => {
    !isGuestB2B && mobileMenuState?.toggleMenuVisibility()
  }

  handleLogoClick = e => {
    e.preventDefault()
    if (isEquinoxPOSite()) {
      const pitchId = getPersonalOfferPitchId()

      this.props.history.push({
        pathname: '/',
        search: pitchId ? `?pitchId=${pitchId}` : '',
      })
      if (IS_BROWSER && window.history?.replaceState) {
        const cleanPath = window.location.pathname.replace(/\/+$/, '')
        window.history.replaceState(
          null,
          '',
          `${cleanPath}${window.location.search}${window.location.hash}`
        )
      }
      return
    }

    this.props.history.push(pageNames?.home)
  }
  render() {
    const isGuestB2B = customerContainer.isGuestB2B
    const requestDomain = this.props?.staticContext?.requestDomain || ''
    const nu_skin_rewards_link =
      contentStackContainer.marketingData?.nu_skin_rewards
        ?.nu_skin_rewards_link || ''
    const { headerNavigation, regionSelector, searchData } = this.props
    const usdLabel = headerNavigation?.usd_label || ''
    const nuSkinRewardsLink = headerNavigation?.link?.href || ''
    const nuSkinRewardsTitle = headerNavigation?.link?.title || ''
    const isNewHeaderEnabled =
      enableNewFeature('enableNewHeaderNavigation') ||
      enableNewFeature('enableRedesignMarketSelector')
    const isEquinoxPO = isEquinoxPOSite()
    const enableDotComHeaderForPO = convertToBoolean(
      getAppConfig()?.enableDotComHeaderForProductOffer
    )
    const hideHamburgerForPO = isEquinoxPO && !enableDotComHeaderForPO
    const disableSignTextMobileHeader = convertToBoolean(
      getAppConfig()?.disableSignTextMobileHeader
    )

    const userMenuOrderClass = disableSignTextMobileHeader
      ? 'order-2 order-md-2'
      : 'order-1 order-md-1'
    const searchOrderClass = disableSignTextMobileHeader
      ? 'order-1 order-md-1'
      : 'order-2 order-md-2'
    const cartOrderClass = 'order-3 order-md-3'

    return (
      <section
        className={`header-middle-container ${
          isNewHeaderEnabled ? 'redesign-main-menu' : ''
        }`}>
        <div className="h-100 p-0">
          <div
            className={`${
              isExpressCheckout() && !getBuyNowInPDP()
                ? 'express-checkout-header'
                : ''
            } h-100 mx-md-0 d-flex flex-wrap align-items-center`}>
            <div
              className={`d-lg-none mr-3 ${hideHamburgerForPO ? 'd-none' : ''}`}>
              <button
                onClick={() => {
                  this.harmsburg(isGuestB2B, requestDomain)
                }}
                className="hide-on-desktop nu-header-pancake-button px-0 header-mobile-view  bg-transparent border-0 pl-0"
                aria-label="navigation menu"
                title="navigation menu">
                <MenuIcon aria-label="navigation menu" />
              </button>
            </div>
            <Link
              data-testid="qa-nuskin-logo-link"
              className="header-Logo"
              onClick={this.handleLogoClick}>
              <HeaderLogo
                requestDomain={requestDomain}
                headerLogoUrl={this.props.headerLogoUrl}
                isNuskinHeader
              />
            </Link>
            <div
              className={`d-flex ml-auto justify-content-between justify-content-lg-end align-items-lg-center order-3 order-md-3 nu-search-right ${disableSignTextMobileHeader ? 'compact-search' : ''}`}>
              {enableNewFeature('enableRedesignMarketSelector') &&
              regionSelector?.countries?.length ? (
                <div
                  className="nav-item-text language-currency-display"
                  aria-label="Current language and currency"
                  tabIndex="0"
                  aria-live="polite"
                  role="button"
                  onClick={this.callMarketFunction}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault()
                      this.callMarketFunction()
                    }
                  }}
                  data-testid="qa-currentLanguageCurrency">
                  {usdLabel}
                  <MarketSelector
                    regionSelector={regionSelector}
                    ref={this.marketSelectorRef}
                  />
                </div>
              ) : (
                <div className="d-none d-lg-block locale_container">
                  <LocaleModal
                    history={this.props.history}
                    isNuskinHeader
                    {...this.props}
                  />
                </div>
              )}

              {enableNewFeature('enableNewHeaderNavigation') ? (
                <>
                  {nuSkinRewardsLink && nuSkinRewardsTitle && (
                    <div className="rewards-link-wrapper">
                      <PageLinks
                        linkInfo={{ link: nuSkinRewardsLink }}
                        className="nav-item-desktop"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="qa-nuskinEnjoyRewardsHeader">
                        <div className="nav-item-inner">
                          <span className="nav-item-texts">
                            {nuSkinRewardsTitle || 'Nu Skin Rewards'}
                          </span>
                        </div>
                      </PageLinks>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {isValidUrl(nu_skin_rewards_link) && (
                    <PageLinks
                      linkInfo={{
                        link: nu_skin_rewards_link,
                      }}
                      className="header_rewards text-decoration-none small mr-3 d-none d-lg-inline"
                      target="_blank"
                      data-testid="qa-nuskinEnjoyRewardsHeader"
                      rel="noopener noreferrer">
                      <span>
                        {i18nTranslate(
                          'header_prototype.nu_skin_rewards_link',
                          'Nu Skin Rewards'
                        )}
                      </span>
                    </PageLinks>
                  )}
                </>
              )}

              <div className={searchOrderClass}>
                <button
                  onClick={() => {
                    this.toggleSearchModal(true)
                  }}
                  ref={this.searchBtnRef}
                  className="hide-on-desktop nu-header-pancake-button px-0 header-mobile-view  bg-transparent border-0 pl-0"
                  aria-label="navigation search"
                  title="navigation search">
                  {enableNewFeature('enableNewHeaderNavigation') ? (
                    <NavSearchIcon aria-label="navigation search" />
                  ) : (
                    <SearchIcon aria-label="navigation search" />
                  )}
                </button>
              </div>
              <div className={`username usermenu ${userMenuOrderClass}`}>
                <UserMenu {...this.props} isNuskinHeader />
              </div>

              {/* <FavoriteIconWithLink className="text-decoration-none favorite-wrapper" /> */}
              <div
                className={
                  enableNewFeature('enableNewHeaderNavigation')
                    ? `pt-md-down-3px ${cartOrderClass}`
                    : `ml-lg-3 ${cartOrderClass}`
                }>
                <CartIcon {...this.props} isNuskinHeader />
              </div>
            </div>
          </div>
          <Modal
            className="search-modal"
            show={this.searchFocused && !application.isDesktopOrLarger}
            dialogClassName="search-modal-fullscreen"
            onHide={() => (this.searchFocused = false)}>
            <Modal.Header className="p-0">
              <div className="w-100 h-100 my-3">
                <SearchBox
                  shouldFocusOnRender={true}
                  isNuskinHeader
                  closeSearchModal={this.closeSearchModal}
                  clearSearchModal={this.clearSearchModal}
                  searchCleared={this.searchCleared}
                  searchData={searchData}
                  {...this.props}
                />
              </div>
              <div className="h-100 text-center d-flex justify-content-center nu-mobile-search-cancel">
                <Button
                  className="search-modal-cancel-button"
                  variant="none"
                  onClick={this.closeSearchSectionModal}>
                  {i18nTranslate('search.cancel', 'CANCEL', {
                    nameSpace: this.nameSpace,
                  })}
                </Button>
              </div>
            </Modal.Header>
            <Modal.Body></Modal.Body>
          </Modal>
        </div>
      </section>
    )
  }
}

export default SearchSection
